import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ fontFamily: 'Segoe UI, Arial, sans-serif', background: '#f9f9f9', minHeight: '100vh' }}>
      
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #6c2eb9)', color: 'white', padding: '40px 20px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: 8 }}>🔐 Politique de Confidentialité</h1>
        <p style={{ opacity: 0.8 }}>TeckiA — L'IA qui simplifie ton quotidien</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 860, margin: '40px auto', background: 'white', borderRadius: 12, boxShadow: '0 2px 20px rgba(0,0,0,0.08)', padding: '50px 60px' }}>
        
        <p style={{ textAlign: 'center', color: '#888', fontSize: '0.85rem', marginBottom: 30 }}>
          Dernière mise à jour : 10 mars 2026
        </p>

        <p style={{ marginBottom: 14 }}>
          La présente Politique de Confidentialité décrit comment <strong>TeckiA</strong>, 
          une application développée par <strong>TDI Digital LLC</strong>,
          collecte, utilise et protège les informations personnelles de ses utilisateurs.
        </p>
        <p style={{ marginBottom: 14 }}>
          En utilisant l'application TeckiA, vous acceptez les termes de cette politique.
        </p>

        <Section title="1. Informations collectées">
          <p>TeckiA peut collecter les types de données suivants :</p>
          <ul>
            <li><strong>Informations de compte :</strong> nom, adresse email, numéro de téléphone lors de l'inscription.</li>
            <li><strong>Données d'utilisation :</strong> fonctionnalités utilisées, fréquence, préférences in-app.</li>
            <li><strong>Contenu généré :</strong> CV, textes, visuels et vidéos créés via les services IA de TeckiA.</li>
            <li><strong>Données de paiement :</strong> transactions via Orange Money (aucune donnée bancaire stockée directement).</li>
            <li><strong>Données de l'appareil :</strong> type d'appareil, système d'exploitation, identifiants techniques.</li>
            <li><strong>Accès caméra et galerie :</strong> uniquement lorsque l'utilisateur initie une action nécessitant ces permissions (upload de photo pour le CV Pro ou le Marketing Studio).</li>
          </ul>
        </Section>

        <Section title="2. Utilisation des informations">
          <p>Les données collectées sont utilisées pour :</p>
          <ul>
            <li>Fournir les services de l'application : Marketing Studio, CV Pro, Compagnon IA, Traducteur, Assistant, TeckiA Infos.</li>
            <li>Gérer votre compte et vos abonnements.</li>
            <li>Traiter vos paiements via Orange Money.</li>
            <li>Vous envoyer des notifications liées à votre compte ou aux mises à jour.</li>
            <li>Analyser l'utilisation pour améliorer les performances et l'expérience.</li>
          </ul>
        </Section>

        <Section title="3. Permissions d'accès">
          <ul>
            <li><strong>CAMERA :</strong> capture de photos pour le Marketing Studio ou le CV Pro.</li>
            <li><strong>READ_EXTERNAL_STORAGE / MEDIA :</strong> accès à vos fichiers images ou documents.</li>
            <li><strong>INTERNET :</strong> fonctionnement des services IA en ligne.</li>
            <li><strong>NOTIFICATIONS :</strong> alertes et rappels utiles.</li>
          </ul>
          <p>Ces permissions ne sont demandées que lorsqu'elles sont nécessaires. Vous pouvez les révoquer dans les paramètres de votre appareil.</p>
        </Section>

        <Section title="4. Partage des données">
          <p>TeckiA ne vend pas vos données personnelles. Elles peuvent être partagées uniquement avec :</p>
          <ul>
            <li>Des prestataires techniques nécessaires au fonctionnement (hébergement, traitement IA, paiements).</li>
            <li>Les autorités compétentes si requis par la loi.</li>
          </ul>
        </Section>

        <Section title="5. Conservation des données">
          <p>Vos données sont conservées aussi longtemps que votre compte est actif. Vous pouvez demander la suppression de votre compte et de toutes vos données à tout moment : envoyez simplement un email à <strong>contact@tdidigital.io</strong> avec l'objet « Suppression de mes données », ou utilisez l'option de suppression de compte dans les paramètres de l'application. Vos données seront supprimées sous 30 jours.</p>
        </Section>

        <Section title="6. Sécurité">
          <p>Nous mettons en œuvre des mesures techniques appropriées pour protéger vos données contre tout accès non autorisé, modification ou destruction.</p>
        </Section>

        <Section title="7. Droits des utilisateurs">
          <ul>
            <li>Droit d'accès à vos données personnelles.</li>
            <li>Droit de rectification des données inexactes.</li>
            <li>Droit à l'effacement (droit à l'oubli).</li>
            <li>Droit d'opposition au traitement.</li>
            <li>Droit à la portabilité de vos données.</li>
          </ul>
        </Section>

        <Section title="8. Enfants">
          <p>TeckiA n'est pas destiné aux enfants de moins de 13 ans. Nous ne collectons pas sciemment de données personnelles auprès de mineurs.</p>
        </Section>

        <Section title="9. Modifications">
          <p>Nous nous réservons le droit de modifier cette politique à tout moment. Toute modification sera notifiée dans l'application.</p>
        </Section>

        <Section title="10. Contact">
          <div style={{ background: '#f3eeff', border: '1px solid #d0b4f5', borderRadius: 8, padding: '20px 24px' }}>
            <ul>
              <li>📧 <strong>Email :</strong> contact@tdidigital.io</li>
              <li>🌐 <strong>Site :</strong> https://tdidigital.io</li>
              <li>🏢 <strong>Développé par :</strong> TDI Digital LLC — États-Unis</li>
            </ul>
          </div>
        </Section>

      </div>

      <footer style={{ textAlign: 'center', padding: 30, fontSize: '0.85rem', color: '#aaa' }}>
        © 2026 TeckiA — TDI Digital LLC. Tous droits réservés.
      </footer>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginTop: 28 }}>
      <h2 style={{ color: '#6c2eb9', fontSize: '1.1rem', borderLeft: '4px solid #6c2eb9', paddingLeft: 12, marginBottom: 12 }}>
        {title}
      </h2>
      <div style={{ lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}